// @flow

import styled from '@emotion/styled'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  quote: string,
  className?: string,
  client?: {
    name: string,
    logo?:
      | React.Element<'img'>
      | React.Element<typeof GatsbyImage>
      | React.Element<typeof StaticImage>,
    description: string,
  },
|}

export default function Quote({ client, quote, className }: Props) {
  return (
    <Root className={className}>
      <QuoteStyled>"{quote}"</QuoteStyled>
      {client && (
        <ClientSection>
          {client.logo}
          <ClientName>
            <Name>{client.name}</Name>
            <Description>{client.description}</Description>
          </ClientName>
        </ClientSection>
      )}
    </Root>
  )
}

const Description = styled(text.P3)`
  color: ${(p) => p.theme.primary};
`

const Name: React.ComponentType<any> = styled(text.P2)`
  font-weight: 700;
  color: ${(p) => p.theme.primary};
`

const ClientSection: React.ComponentType<any> = styled.div`
  margin-top: 25px;
  ${media.mq[1]} {
    margin-top: 31px;
    display: flex;
    align-items: center;
  }

  .gatsby-image-wrapper {
    width: 55px;
    margin-bottom: 10px;

    ${media.mq[1]} {
      margin-right: 20px;
      margin-bottom: 0;
    }
  }
`

const ClientName = styled.div`
  margin: auto;
  text-align: center;
`

const QuoteStyled: React.ComponentType<any> = styled(text.H3)`
  text-align: center;
`

const Root: React.ComponentType<any> = styled.div`
  width: 100%;
  padding: 45px 30px;
  display: flex;
  flex-direction: column;
  color: ${colors.beige};
  background-color: ${colors.darkPurple};
  ${media.mq[1]} {
    padding: 60px 120px;
    width: auto;
  }
`
